module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.27.0-de48ae84e.svg#arrow-small","viewBox":"0 0 7 12"}